export const projects = [
    {
        name: "DAKA Daily Check-In Application",
        description_1: 'Implemented in group of three with Swift and SwiftUI for the native front-end appearance, along with Google Firebase real-time database.',
        description_2: 'Obtained a better understanding of MVVM software architecture of an iOS application via Swift from front-end to back-end.',
        url: 'https://github.com/haoranli17365/Swift_DAKA_APP'
    },
    {
        name: "Advanced Data Structures in Java",
        description_1: 'Implemented hash table with linear probing and sperate chaining technique. KD-Tree, Quad-Tree and AVL Tree along with basic data structures such as linked list, min/max heap, priority queue.',
        description_2: 'Strengthen the ability to code in Java and reviewed OOP principle.',
        url: 'https://github.com/haoranli17365/CMSC420-Spatial'
    },
    {
        name: "Image Segmenation - UNet",
        description_1: 'Image Segmentation with UNet architecture for cell images using PyTorch.',
        description_2: 'Implemented and trained the UNet network. Manipulate the input pairs with augmentaion techniques including flips, rotations and scaling to increase training quality.',
        url: 'https://github.com/haoranli17365/UNet_Image_Segmentation'
    }
]